import Component from './TransactionHistory'

export default Component
